export default (desc, brands, cardPrefix) => {
  const brandName = brands[desc?.split(' ')[0]];
  if (!cardPrefix || cardPrefix?.includes('undefined') || !desc || desc?.includes('undefined'))
    return 'Manually approved payment';
  if (brandName) {
    return `${brandName}${' '}${desc.split(' ')[1].replace(/x/g, cardPrefix)}`;
  }
  return desc;
};
